var axios = require("axios");

export const contactUs = async (content) => {
  const getNotNullValue = function (obj) {
    if ([undefined, null, "undefined", "null"].includes(obj)) {
      return "";
    }
    return obj;
  };

  const huiju_getToken = async (appid, secret) => {
    const { data } = await axios.get(`/api/huiju-accesstoken`);
    return data.data.access_token;
  };

  const huiju_getCustomer = async (access_token, type, query) => {
    let param = "";
    switch (type) {
      case "phone":
        param = `mobile=${query}`;
        break;
      case "email":
        param = `email=${query}`;
        break;
      default:
        param = `mobile=${query}`;
    }
    try {
      const { data } = await axios.get(
        `/api/huiju-getApi?access_token=${access_token}&${param}`
      );
      return data.data.data[0];
    } catch (error) {
      return "error";
    }
  };

  let token = await huiju_getToken(
    "cl01a1180ccb62048",
    "b62531b57a2e0e5383be08da6fb87a7cf7420f57"
  );
  let customer = await huiju_getCustomer(token, "phone", content.phone);
  const feishuData = {
    customerId: getNotNullValue(customer?.idStr) || "",
    displayName:
      getNotNullValue(content.name) || getNotNullValue(customer.displayName),
    email: getNotNullValue(content.email) || getNotNullValue(customer.email),
    phone: getNotNullValue(content.phone) || getNotNullValue(customer.mobile),
    companyPosition:
      getNotNullValue(content.company_position) ||
      getNotNullValue(customer.phone),
    companyName:
      getNotNullValue(content.company) || getNotNullValue(customer.company),
    companySize:
      getNotNullValue(content.company_size) ||
      getNotNullValue(content.employeeNumber),
    city: getNotNullValue(content.city) || getNotNullValue(customer.city),
    func: getNotNullValue(content.func) || "",
    remark: getNotNullValue(content.other) || getNotNullValue(customer.remark),
    utmSource: getNotNullValue(content.utm_source),
    utmMedium: getNotNullValue(content.utm_medium),
    utmCampaign: getNotNullValue(content.utm_campaign),
    utmTerm: getNotNullValue(content.utm_term),
  };
  const codaData = {
    // value 值不能为 null，undefined/"" 可以
    rows: [
      {
        cells: [
          {
            column: "c-OfeNHjFgFp", // 渠道名称
            value: "官网留资",
          },
          {
            column: "c-Y8iTVc18vK", // 公司名
            value: content.company || "",
          },
          {
            column: "c-mkuebT1N_t", // 联系人
            value: content.name || "",
          },
          {
            column: "c-WPXPlliJpY", // 电话/座机
            value: content.phone || "",
          },
          {
            column: "c-BvyZ6aMgMh", // 线索创建时间
            value: new Date(),
          },
        ],
      },
    ],
  };
  // https://core.uat.authing-inc.co/api/v2/consult-us
  const res = await axios.post("https://core.authing.cn/api/v2/consult-us", {
    feishuData: feishuData,
    codaData: codaData,
  });
  return res;
};
